import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatTooltip } from '@angular/material/tooltip';

import { ApmTranslatePipe, AuthFacade } from '@mitsubishi/core';
import { ResourceImageDirective, SelectModule } from '@mitsubishi/shared/ui';

import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
  selector: 'apm-select-type',
  templateUrl: './select-type.component.html',
  styleUrls: ['./select-type.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatTooltip, ApmTranslatePipe, NgClass, ResourceImageDirective, SelectModule, ReactiveFormsModule],
})
export class SelectTypeComponent extends FieldType<FieldTypeConfig> implements OnInit {
  #authFacade = inject(AuthFacade);

  canDebug = this.#authFacade.canDebug;
  selectOptions: any[] = [];

  ngOnInit() {
    if (this.canDebug) {
      this.selectOptions = [];
      this.props.options?.forEach(opt => {
        this.selectOptions?.push({ label: `${opt.value} - ${opt.label}`, value: opt.value });
      });
    } else {
      this.selectOptions = (this.props.options as any) ?? [];
    }
  }

  searchFn(
    term: string,
    item: {
      label: string;
      value: string;
      groupValue?: string;
    }
  ) {
    term = term.toLowerCase();
    return (
      item.label.toLowerCase().includes(term) ||
      item.value.toLowerCase().includes(term) ||
      item.groupValue?.toLowerCase().includes(term)
    );
  }
}
